import React, {JSX, useState} from 'react';

import classNames from 'classnames';

import {Item} from '@pb/kit-component-group';
import {Cell} from '@pb/kit-component-table';

import {CompareChangesModal} from '../compare-changes-modal/compare-changes-modal';

import {highlighterWrapperClickable, highlighterWrapperHighlight} from './highlighter-wrapper.module.styl';

type Props = {
    caption?: string,
    actualValue?: string,
    changeRequestValue?: string,
    highlight: boolean,
    clickable?: boolean,
    tableCell?: boolean,
    children: JSX.Element,
};

export const HighlighterWrapper = (props: Props) => {
    const {
        caption,
        actualValue,
        changeRequestValue,
        children,
        highlight,
        tableCell = false,
        clickable = true,
    } = props;

    const [shown, setShown] = useState(false);

    const onClose = () => setShown(false);

    const onClick = () => {
        if (!highlight || !clickable || shown) {
            return;
        }

        setShown(true);
    };

    const classes = classNames({
        [highlighterWrapperHighlight]: highlight,
        [highlighterWrapperClickable]: clickable && highlight,
    });

    return (
        <>
            <CompareChangesModal
                caption={caption}
                actualValue={actualValue}
                changeRequestValue={changeRequestValue}
                shown={shown}
                setShown={setShown}
                onClose={onClose}
            />
            {tableCell ? (
                <Cell
                    onClick={onClick}
                    title={changeRequestValue}
                    className={classes}
                    verticalAlign="middle">
                    {children}
                </Cell>
            ) : (
                <Item className={classes} onClick={onClick}>
                    {children}
                </Item>
            )}
        </>
    );
};
